"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreadcrumbSeparatorStyleConfig = exports.designSystemBreadcrumbSeparatorStyleConfig = exports.defaultBreadcrumbSeparatorStyleConfig = exports.getBreadcrumbItemStyleConfig = exports.designSystemBreadcrumbItemStyleConfig = exports.defaultBreadcrumbItemStyleConfig = void 0;
var react_1 = require("@emotion/react");
var design_system_colors_1 = require("../../style/theme/design-system-colors");
var constant_1 = require("../../constant");
exports.defaultBreadcrumbItemStyleConfig = {
    default: {
        marginRight: '0.5rem',
        textDecoration: 'none',
    },
    active: {},
};
exports.designSystemBreadcrumbItemStyleConfig = {
    default: {
        color: design_system_colors_1.DesignSystemThemeColor.Primary.DEFAULT,
        marginRight: '0.75rem',
        cursor: 'pointer',
        userSelect: 'none',
    },
    active: {
        color: design_system_colors_1.DesignSystemThemeColor.Gray.DEFAULT,
        cursor: 'text',
    },
};
var getBreadcrumbItemDefaultConfig = function (theme) { return ({
    container: react_1.css(__assign(__assign({}, theme.content), exports.defaultBreadcrumbItemStyleConfig.default)),
    activeContainer: react_1.css(__assign({}, exports.defaultBreadcrumbItemStyleConfig.active)),
}); };
var getBreadcrumbItemDesignConfig = function () { return ({
    container: react_1.css(__assign({}, exports.designSystemBreadcrumbItemStyleConfig.default)),
    activeContainer: react_1.css(__assign({}, exports.designSystemBreadcrumbItemStyleConfig.active)),
}); };
var getBreadcrumbItemStyleConfig = function (theme) { return theme.name === constant_1.DESIGN_SYSTEM
    ? getBreadcrumbItemDesignConfig()
    : getBreadcrumbItemDefaultConfig(theme); };
exports.getBreadcrumbItemStyleConfig = getBreadcrumbItemStyleConfig;
exports.defaultBreadcrumbSeparatorStyleConfig = {
    default: {
        marginRight: '0.5rem',
    },
};
exports.designSystemBreadcrumbSeparatorStyleConfig = {
    default: {
        marginRight: '0.75rem',
    },
};
var getBreadcrumbSeparatorDefaultConfig = function (theme) { return ({
    container: react_1.css(__assign(__assign({}, theme.content), exports.defaultBreadcrumbSeparatorStyleConfig.default)),
}); };
var getBreadcrumbSeparatorDesignConfig = function (theme) { return ({
    container: react_1.css(__assign(__assign({}, exports.designSystemBreadcrumbSeparatorStyleConfig.default), { display: 'flex', alignItems: 'center', color: theme.color.GRAY.LIGHT_2 })),
}); };
var getBreadcrumbSeparatorStyleConfig = function (theme) { return theme.name === constant_1.DESIGN_SYSTEM
    ? getBreadcrumbSeparatorDesignConfig(theme)
    : getBreadcrumbSeparatorDefaultConfig(theme); };
exports.getBreadcrumbSeparatorStyleConfig = getBreadcrumbSeparatorStyleConfig;
